export default __webpack_public_path__ + "static/media/ColorWheel.c4acc351.png";